import Table from "@/ui/components/Table"
import Button from "@/ui/components/Button"

import type { IUser } from "@/types/user/IUser"
import { useEffect, useState, type FC } from "react"
import * as TrinityAPI from "@/requests/TrinityAPI"

import style from "../style.module.scss"
import { spacedNum } from "@/components/common/CommonHelper"
import { IModalMessage } from "@/types/error/IModalMessage"

type Props = {
  item: IUser
  extendedUserId: number | null
  setExtendedUserId: (value: number | null) => void
  onExchange: (user: IUser) => void
  onViewHistory: (user: IUser) => void
  setModalMessage: (value: IModalMessage | null) => void
}

export const CurrecyExchangeUserItem: FC<Props> = ({
  item,
  onExchange,
  extendedUserId,
  setExtendedUserId,
  setModalMessage,
  onViewHistory
}) => {
  const isShowMore = extendedUserId === item.userId

  const { balances } = item

  const [userBalances, setUserBalances] = useState<Record<string, number> | null>(null)

  const handleItemClick = () => {
    if (isShowMore) {
      setExtendedUserId(null)

      return
    }

    setExtendedUserId(item.userId || null)
  }

  const getFormattedMoney = (currency: string) =>
    spacedNum(((balances?.find(el => el.currency === currency)?.amount || 0) / 100).toFixed(2))

  useEffect(() => {
    if (!!userBalances || !item.userId || !isShowMore) {
      return
    }

    TrinityAPI.getAdminUserBalances(item.userId, response => {
      if (response.status === 200) {
        setUserBalances(response.data)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка загрузки балансов пользователя: " + response.data.message })
      }
    })
  }, [isShowMore, userBalances])

  return (
    <>
      <Table.Item className={style.usersTableRow} onClick={handleItemClick} isActive={isShowMore} isClickable>
        <div>{item.name || "-"}</div>
        <div>{item.username || "-"}</div>
        <div>{balances?.find(el => el.currency === "USD")?.amount ? getFormattedMoney("USD") : "0"}</div>
        <div>{balances?.find(el => el.currency === "EUR")?.amount ? getFormattedMoney("EUR") : "0"}</div>
        <div>{balances?.find(el => el.currency === "CNY")?.amount ? getFormattedMoney("CNY") : "0"}</div>
        <div>{balances?.find(el => el.currency === "AED")?.amount ? getFormattedMoney("AED") : "0"}</div>
        <div className={style.rowActionsColumn}>
          <Button
            onClick={e => {
              e.stopPropagation()
              onExchange(item)
            }}
            size="small"
          >
            Обменять
          </Button>
          <Button
            variant="black"
            size="small"
            onClick={e => {
              e.stopPropagation()
              onViewHistory(item)
            }}
            disabled={!item.hasExchanges}
          >
            История обменов
          </Button>
        </div>
      </Table.Item>
      <Table.Extended isVisible={isShowMore}>
        <div className={style.extendedTitle}>Балансы и ставки:</div>
        <p>*Если валюта не указана в списке, ее баланс 0</p>
        <div className={style.balances}>
          {!!userBalances &&
            Object.keys(userBalances).map(el => (
              <div>
                <div>{el}:</div>
                <div>{spacedNum(((userBalances[el] || 0) / 100).toFixed(2))}</div>
              </div>
            ))}
        </div>
      </Table.Extended>
    </>
  )
}
